module.exports = __webpack_public_path__ + "static/media/offices-bg.7e177b14.jpg";